"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditState = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const input_state_group_1 = require("../components/input/input.state.group");
const form_edit_model_1 = require("../store/form.edit.model");
const mobx_2 = require("./mobx");
class FormEditState extends mobx_2.MobxState {
    constructor(form) {
        super();
        this.inputStates = new input_state_group_1.IkeInputStateGroup();
        this.formRevision = form.revision;
        this.editState = new form_edit_model_1.FormModelEditState(form);
        this.form = new core_shared_1.FormModelEdit(form, this.editState);
    }
    reset() {
        this.editState.reset();
    }
    revert(fieldId) {
        this.editState.fields.delete(fieldId);
    }
    discard() {
        if (this.editState != null) {
            this.editState.reset();
        }
    }
    isFieldDirty(fieldId) {
        return this.editState.fields.has(fieldId);
    }
    get isDirty() {
        return this.editState.isDirty;
    }
    get isValid() {
        return this.inputStates.isValid;
    }
    get canSubmit() {
        return this.inputStates.canSubmit;
    }
}
exports.FormEditState = FormEditState;
tslib_1.__decorate([
    mobx_1.action
], FormEditState.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action
], FormEditState.prototype, "revert", null);
tslib_1.__decorate([
    mobx_1.action
], FormEditState.prototype, "discard", null);
//# sourceMappingURL=form.edit.state.js.map